//'use strict';

/**
* @ngdoc service
* @name tcApp.ComponentListService
* @description
* Service that provides functions for component list behavior used by component controller
*  and workflow service
*/
angular.module('tcApp').factory('ComponentListService', function($rootScope, ElementStateService, tcConstants) { 

	// Sets a list row as the active row, removes active flag from any other rows
	// activeRowIndex passed as null will clear the active row
	var setListActiveRow = function($scope, activeRowIndex) {
		angular.forEach($scope.data.listRows, function(listRow, listRowIndex) {
			if (activeRowIndex === listRowIndex) {
				listRow._active = true;
			} else {
				delete listRow._active;
			}
		});
	};
	
	// Sets the current active row as the chain selection row, removes chain selection from any other rows
	// activeRowChainIndex passed as null will remove the current chain selection row
	var setListActiveRowChain = function($scope, activeRowChainIndex, chainOtherActiveRows) {
		angular.forEach($scope.data.listRows, function(listRow) {
			if ((activeRowChainIndex !== null)
				&& ((listRow._active) || (listRow._selected))) {
				listRow._activeChain = true;
			} else {
				delete listRow._activeChain;
			}
		});
		if (chainOtherActiveRows) {
			$rootScope.$broadcast('Component:setListActiveRowChain', $scope.componentHtmlName, activeRowChainIndex);
		}
	};
	
	/// returns the ElementState collapsed cache for a list row group
	var getListGroupCollapsedCache = function(componentHtmlName, currentPage, listGroupIndex) {
		var cachedKey = getListGroupCollapsedCachedKey(componentHtmlName, currentPage, listGroupIndex);
		return ElementStateService.get(cachedKey);
	};
	
	/// sets the ElementState collapsed cache for a list row group
	var setListGroupCollapsedCache = function(componentHtmlName, currentPage, listGroupIndex, collapsedState) {
		var cachedKey = getListGroupCollapsedCachedKey(componentHtmlName, currentPage, listGroupIndex);
		ElementStateService.set(cachedKey, collapsedState);
	};
	
	/// returns the ElementState cachedKey for a list row group
	var getListGroupCollapsedCachedKey = function(componentHtmlName, currentPage, listGroupIndex) {
		return (componentHtmlName + '-rowGroup-collapsed-page-' + currentPage + '-group-' + listGroupIndex);
	};
	
	/// removed in workflowService inCoseReload for all lists on the route
	var clearAllListCollapsedCache = function(routeKey) {
		ElementStateService.removeKeysContaining('-rowGroup-collapsed-', routeKey);
	};
	
	/// removes the ElementState collapsed cache for the list, and optionally reset the list to default state
	var clearListGroupCollapsedCache = function($scope, resetToDefault) {
		$scope.viewModel.listSettings.collapsedGroups = [];
		ElementStateService.removeKeysForComponent($scope.componentHtmlName + '-rowGroup-collapsed');
		if ((resetToDefault) && (!$scope.viewModel.listSettings.selectMode)
		&& (angular.isDefined($scope.data.listRows[0]._groupColumnCount))) {
			var currentPage = ($scope.data.listData.pageCount - 1);
			$scope.viewModel.listSettings.collapsedGroups[currentPage] = [];
			angular.forEach($scope.data.listRows, function(listRow) {
				if (angular.isDefined(listRow['_groupColumnCount'])
				&& (angular.isDefined(listRow['_groupColumnCollapsed'])	&& (listRow['_groupColumnCollapsed']))) {
					$scope.viewModel.listSettings.collapsedGroups[currentPage][listRow['_groupColumnCount']] = true;
				}
			});
		}
	};
	
	var isListSorted = function($scope) {
		return (angular.isDefined($scope.data.listData.sortColumn)
						&& ($scope.data.listData.sortColumn !== ''));
	};
	
	var isListGrouped = function($scope) {
		return (angular.isDefined($scope.data.items.TGROUPBYCOLUMN)
				&& angular.isDefined($scope.data.items.TGROUPBYCOLUMN.valueId)
				&& ($scope.data.items.TGROUPBYCOLUMN.valueId !== ''));
	};
	
	var isListFiltered = function($scope) {
		return ((angular.isDefined($scope.data.listData.filterDateFrom)
					&& ($scope.data.listData.filterDateFrom.value !== ''))
				|| (angular.isDefined($scope.data.listData.filterDateTo)
					&& ($scope.data.listData.filterDateTo.value !== '')));
	};
	
	/// Returns the list options caption based on the applied list operations
	var getListOptionsCaption = function($scope) {
		if (angular.isUndefined($scope.data.listData)) return '';
		// when GetData throws an error and not all the jsonReponse properties are returned.
		var translations = $scope.data.translations;
		if (angular.isObject($scope.data.error) && angular.isUndefined(translations)) {
			translations = {};
		}
		
		var listOptionsCaption = '';
		var isSorted = isListSorted($scope);
		var isGrouped = isListGrouped($scope);
		var isFiltered = isListFiltered($scope);
		
		if (isGrouped || isFiltered) {
			if (isFiltered) listOptionsCaption += $scope.globalStrings['XLISTFILTERED'];
			if (isGrouped) {
				if (listOptionsCaption !== '') listOptionsCaption += ', ';
				if (isFiltered || isSorted) {
					listOptionsCaption += $scope.globalStrings['XLISTGROUPED'];
				} else {
					listOptionsCaption += ($scope.globalStrings['XLISTGROUPEDBY'] + ' ' + $scope.data.items.TGROUPBYCOLUMN.value);
				}
			}
			if (isSorted) {
				if (listOptionsCaption !== '') listOptionsCaption += ', ';
				listOptionsCaption += ($scope.globalStrings['XLISTSORTED']);
			}
		} else if (isSorted) {
			listOptionsCaption += ($scope.globalStrings['XSORTEDBY'] + ' ');
			listOptionsCaption += translations[$scope.data.listData.sortColumn];
			if (angular.isDefined($scope.data.listData.sortSecondaryColumn)
				&& ($scope.data.listData.sortSecondaryColumn !== '')) {
				listOptionsCaption += (', ' + translations[$scope.data.listData.sortSecondaryColumn]);
			}
		}
		
		return listOptionsCaption;
	};
	
	/// Returns the list options tooltip text based on the applied list operations
	var getListOptionsTooltip = function($scope) {
		if (angular.isUndefined($scope.data.listData)) return '';
		// when GetData throws an error and not all the jsonReponse properties are returned.
		var translations = $scope.data.translations;
		if (angular.isObject($scope.data.error) && angular.isUndefined(translations)) {
			translations = {};
		}
		
		var listOptionsTooltip = '';
		var isSorted = isListSorted($scope);
		var isGrouped = isListGrouped($scope);
		var isFiltered = isListFiltered($scope);
		
		if (isFiltered) listOptionsTooltip += $scope.globalStrings['XLISTFILTERED'];
		if (isGrouped) {
			if (listOptionsTooltip !== '') listOptionsTooltip += ', ';
			listOptionsTooltip += ($scope.globalStrings['XLISTGROUPEDBY'] + ' ' + $scope.data.items.TGROUPBYCOLUMN.value);
		}
		if (isSorted) {
			if (listOptionsTooltip !== '') listOptionsTooltip += ', ';
			listOptionsTooltip += ($scope.globalStrings['XSORTEDBY'] + ' ');
			listOptionsTooltip += (translations[$scope.data.listData.sortColumn] + ' ');
			if ($scope.data.listData.sortOrder === tcConstants.SORT_ORDER.ASCENDING) {
				listOptionsTooltip += $scope.globalStrings['XASCEND'];
			} else {
				listOptionsTooltip += $scope.globalStrings['XDESCEND'];
			}
			if (angular.isDefined($scope.data.listData.sortSecondaryColumn)
				&& ($scope.data.listData.sortSecondaryColumn !== '')) {
				listOptionsTooltip += (', ' + translations[$scope.data.listData.sortSecondaryColumn] + ' ');
				if ($scope.data.listData.sortSecondaryOrder === tcConstants.SORT_ORDER.ASCENDING) {
					listOptionsTooltip += $scope.globalStrings['XASCEND'];
				} else {
					listOptionsTooltip += $scope.globalStrings['XDESCEND'];
				}
			}
		}
		
		if (listOptionsTooltip !== '') {
			if (angular.isDefined($scope.data.componentHeaderCaption) && ($scope.data.componentHeaderCaption !== '')) {
				listOptionsTooltip = ($scope.data.componentHeaderCaption + ' ' + listOptionsTooltip);
			}
			listOptionsTooltip += '. ';
		}
		listOptionsTooltip += ($scope.globalStrings['XLISTOPENPANEL']);
		
		return listOptionsTooltip;
	};
	
	/// loops with the list to check if any groupBy rows are collapsed, or nestedList items are collapsed
	///  then sets the viewModel.listSettings.hasCollapsedRows for the toggleExpandCollapse header icon
	var setListHasCollapsedRows = function($scope) {
		if (!angular.isArray($scope.data.listRows)) return;
		if (angular.isDefined($scope.data.listRows[0]['_groupColumnCount'])) {
			var currentPage = ($scope.data.listData.pageCount - 1);
			for (var groupIndex=0; groupIndex<$scope.viewModel.listSettings.collapsedGroups[currentPage].length; groupIndex++) {
				if ($scope.viewModel.listSettings.collapsedGroups[currentPage][groupIndex]) {
					$scope.viewModel.listSettings.hasCollapsedRows = true;
					return;
				}
			}
		} else {
			for (var rowIndex=0; rowIndex<$scope.data.listRows.length; rowIndex++) {
				if (getListHasCollapsedRowItem($scope.data.listRows[rowIndex], $scope.data.listData.nestedListItems)) {
					$scope.viewModel.listSettings.hasCollapsedRows = true;
					return;
				}
			}
		}
		$scope.viewModel.listSettings.hasCollapsedRows = false;
	};
	
	/// For a list row object, returns if any nested item on that row is collapsed
	var getListHasCollapsedRowItem = function(listRow, nestedItems) {
		var itemsToExpand = false;
		var item;
		angular.forEach(nestedItems, function(itemRef, itemName) {
			item = listRow[itemName];
			if (angular.isUndefined(item)) return;
			if (item.displayType === 'CX') {
				if (!item.expanded) itemsToExpand = true;
			}
		});
		return itemsToExpand;
	};

	/// Returns nested component details recursively
	var getNestedComponentDetails = function(componentData) {
		if (angular.isUndefined(componentData)) {
			return {
				nestedComponentNames: [],
				nestedModelClassNames: [],
			};
		}
		var nestedComponentNames=[];
		var nestedModelClassNames=[];

		angular.forEach(componentData.items, function(item) {
			if (item.displayType !== 'CX') return;
			if (angular.isUndefined(item.componentData)) return;
			if (angular.isUndefined(item.componentData.componentName)) return;
			if (item.componentData.componentName === '') return;

			if (!nestedComponentNames.includes(item.componentData.componentName)) {
				nestedComponentNames.push(item.componentData.componentName);
				nestedModelClassNames.push(item.componentData.modelClassName);
			}
			// Recurse through the nested components
			var itemNestedComponentDetails = getNestedComponentDetails(item.componentData);
			nestedComponentNames = nestedComponentNames.concat(itemNestedComponentDetails['nestedComponentNames']);
			nestedModelClassNames = nestedModelClassNames.concat(itemNestedComponentDetails['nestedModelClassNames']);
		});

		if (angular.isDefined(componentData.listRows)) {
			for (var listRowIndex = 0; listRowIndex < componentData.listRows.length; listRowIndex++) {
				angular.forEach(componentData.listRows[listRowIndex], function(item, key) {
					// Ignore any row metadata
					if ((key.substr(0, 1) === '_') || (key.substr(0, 2) === '$$')) return;
					if (item.displayType !== 'CX') return;
					if (angular.isUndefined(item.nestedComponentName)) return;
					if (item.nestedComponentName === '') return;

					if (!nestedComponentNames.includes(item.nestedComponentName)) {
						nestedComponentNames.push(item.nestedComponentName);
						if (angular.isUndefined(item.componentData)) nestedModelClassNames.push('');
					}
					if (angular.isUndefined(item.componentData)) return;
					nestedModelClassNames.push(item.componentData.modelClassName);

					// Recurse through the nested components
					var itemNestedComponentDetails = getNestedComponentDetails(item.componentData);
					nestedComponentNames = nestedComponentNames.concat(itemNestedComponentDetails['nestedComponentNames']);
					nestedModelClassNames = nestedModelClassNames.concat(itemNestedComponentDetails['nestedModelClassNames']);
				});
			}
		}

		return {
			nestedComponentNames: nestedComponentNames,
			nestedModelClassNames: nestedModelClassNames,
		};
	};

	return {
		setListActiveRow: setListActiveRow,
		setListActiveRowChain: setListActiveRowChain,
		getListGroupCollapsedCache: getListGroupCollapsedCache,
		setListGroupCollapsedCache: setListGroupCollapsedCache,
		clearListGroupCollapsedCache: clearListGroupCollapsedCache,
		clearAllListCollapsedCache: clearAllListCollapsedCache,
		getListOptionsCaption: getListOptionsCaption,
		getListOptionsTooltip: getListOptionsTooltip,
		setListHasCollapsedRows: setListHasCollapsedRows,
		getListHasCollapsedRowItem: getListHasCollapsedRowItem,
		getNestedComponentDetails: getNestedComponentDetails,
	};
});
